import Spinner from '../design-system/spinner';

const BUTTON_LOADING_CLASS_NAME = 'btn--loading';
const SPINNER_CLASS_NAME = '.js-spinner';

const addFixedWidth = (target) => {
  const boundingRect = target.getBoundingClientRect();

  target.style.width = `${Math.round(boundingRect.width)}px`;
};

const removeFixedWidth = (target) => target.style.width = '';

const addLoadingState = (target) => {
  const color = target.classList.contains('btn--outline')
    ? { color: 'red' }
    : { color: 'white' };

  const spinner = new Spinner(color);

  addFixedWidth(target);

  target.classList.add(BUTTON_LOADING_CLASS_NAME);
  target.appendChild(spinner.build());
};

const removeLoadingState = (target) => {
  const spinnerElement = target.querySelector(SPINNER_CLASS_NAME);

  removeFixedWidth(target);

  target.classList.remove(BUTTON_LOADING_CLASS_NAME);

  if (spinnerElement) {
    target.removeChild(spinnerElement);
  }
};

export { addLoadingState, removeLoadingState };
